<!--
 * @Author: BeanDou
 * @LastEditors: BeanDou
 * @Date: 2020-06-17 15:55:04
 * @LastEditTime: 2020-06-18 16:36:46
 * @Description: File description
-->
<template>
  <div class="choiceOrg">
    <div class="mainWrapper">
      <div class="org-list">
        <el-popover
          popper-class="org-popover"
          placement="bottom-start"
          trigger="hover">
          <ul>
            <li
              v-for="(item, index) in orgList"
              :key="index"
              :class="{isOrgSelect: item.id === currentOrg.id}"
              @click="changeOrg(item)"
            >{{ item.school.name ? item.school.name : '' }}</li>
          </ul>
          <el-button class="popover-btn" slot="reference">
            <div class="choice-org">
              <span></span>
              <span>{{ currentOrg.school? currentOrg.school.name : '' }}</span>
            </div>
          </el-button>
        </el-popover>
      </div>
      <div class="content">
        <p>今日编程课排课信息：</p>
        <ul class="list-title">
          <li class="course-header">
              <span>排课时间</span>
              <span>班级名称</span>
              <span>讲次信息</span>
              <span>授课老师</span>
          </li>
        </ul>
        <ul v-if="courseList.length" class="list">
            <template
              v-for="(item, index) in courseList"
            >
              <li
                class="course-item"
                :class="{ isSelect: currentItem.id === item.id }"
                :key="index"
                @click="selectCourse(item)"
              >
                <span>{{ item.start_time }} - {{ item.end_time }}</span>
                <span :title="item.class_name">{{ item.class_name }}</span>
                <span>第{{ item.index }}讲</span>
                <span>{{ item.teacher_name }}</span>
              </li>
            </template>
        </ul>
        <div v-else class="list no-list">
          暂无课程信息
        </div>
        <div class="btns">
          <el-button @click="btnBehavior('beginClass')" class="start-class-btn" type="primary">上课</el-button>
          <el-button @click="btnBehavior('practice')" class="practice" type="primary">练习</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import authApi from '@/services/auth/index'
export default {
  name: 'choiceOrg',
  data () {
    return {
      currentTab: 0,
      lastLoggedUser: {},
      courseList: [],
      currentItem: {},
      orgList: [],
      currentOrg: {},
      user_token: ''
    }
  },
  created () {
    const schoolList = localStorage.getItem('studentList') ? JSON.parse(localStorage.getItem('studentList')) : null;
    const currentOrgInfo = localStorage.getItem('currentOrgInfo') ? JSON.parse(localStorage.getItem('currentOrgInfo')) : null;
    if (schoolList) {
      this.orgList = schoolList
    }
    if (currentOrgInfo) {
      this.currentOrg = currentOrgInfo;
    }
    this.getOrgLessonList()
  },
  methods: {
    selectCourse (item) {
      this.currentItem = item
    },
    /**
     * 获取课程列表
     */
    getOrgLessonList () {
      authApi.getOrgLessonList().then(res => {
        if (res.ok) {
          this.courseList = res.data.lessons
          this.currentItem = this.courseList[0]
          this.user_token = res.data.user_token;
        }
      })
    },
    /**
     * 切换机构
     */
    changeOrg(item) {
      authApi.changeOrg(item).then(res => {
        if (res.ok) {
          const data = res.data;
          this.orgList.forEach((item, index) => {
            if (item.id === data.student_info.id) {
              this.currentOrg = item;
              localStorage.setItem('currentOrgInfo', JSON.stringify(item));
            }
          })
          this.getOrgLessonList()
        }
      })
    },
    jumpObj() {
      const { school_id} = this.currentOrg;
      const user_id = this.currentOrg.id;
      const live_org_lesson_id = this.currentItem.id;
      const { lesson_id, lesson_start_at, lesson_end_at } = this.currentItem;
      return {
        school_id,
        lesson_id,
        lesson_start_at,
        lesson_end_at,
        user_id,
        live_org_lesson_id
      }
    },
    /**
     * 开始上课
     */
    async btnBehavior(behavior) {
      if (!this.currentItem) {
        this.$toast.warning('暂无课程信息')
        return;
      }
      const data = await authApi.getOrgLessonList();
      // learn_url 上课  exercise_url 练习  timestamp 服务器时间
        const { timestamp, exercise_url, learn_url } = data.data;
      if (behavior === 'beginClass') {
        if (timestamp < this.currentItem.lesson_start_at - 10 * 60 || timestamp > this.currentItem.lesson_end_at + 30 * 60) {
          this.$toast.warning('当前课程不在上课时间，请重新选择课程');
          return;
        }
      }
      const params = this.jumpObj();
      console.log(`${behavior === 'beginClass' ? learn_url : exercise_url}?school_id=${params.school_id}&user_id=${params.user_id}&live_org_lesson_id=${params.live_org_lesson_id}&lesson_id=${params.lesson_id}&lesson_start_at=${params.lesson_start_at}&lesson_end_at=${params.lesson_end_at}&auth=1&user_token=${encodeURIComponent(this.user_token)}`)
      // return;
      window.location.href = `${behavior === 'beginClass' ? learn_url : exercise_url}?school_id=${params.school_id}&user_id=${params.user_id}&live_org_lesson_id=${params.live_org_lesson_id}&lesson_id=${params.lesson_id}&lesson_start_at=${params.lesson_start_at}&lesson_end_at=${params.lesson_end_at}&auth=1&user_token=${encodeURIComponent(this.user_token)}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .choiceOrg {
    width: 100%;
    height: 100%;
    background-color: #F1F3F8;
    .mainWrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      width: 1000px;
      padding: 82px 0 155px 131px;
      background: #fff;
      z-index: 1;
      @include panel-rounded;
      @include panel-blur;
      .org-list {
        position: absolute;
        top: 30px;
        left: 140px;
        ul {
          padding: 0;
        }
      }
      .popover-btn {
        border: 0;
        padding: 0;
      }
      .popover-btn:hover {
        background-color: #fff;
      }
      .choice-org {
        span:first-child {
          display: inline-block;
          vertical-align: top;
          width: 26px;
          height: 26px;
          background-image: url(../../assets/icons/choice.png);
          background-size: 26px 26px;
        }
        span:last-child {
          padding-left: 6px;
          line-height: 26px;
          font-size: 15px;
          color: #202429;

        }
      }
      .content {
        height: 313px;
        border-radius: 10px;
        background-color: #F9FAFB;
        p {
          padding-left: 17px;
          height: 43px;
          line-height: 43px;
          color: #000;
          font-size: 14px;
          text-align: left;
          border-bottom: 1px solid #E1E1E1;
        }
        .no-list {
          line-height: 200px;
          font-size: 15px;
        }
        .list-title, .list {
          margin-bottom: 32px;
          height: 227px;
          width: 700px;
          box-sizing: border-box;
          padding: 0 3px 0;
          overflow-y: auto;
          border-radius: 5px;
          li {
              height: 43px;
              line-height: 43px;
              font-size: 0;
              cursor: pointer;
              color: #323232;
              span {
                  font-size: 16px;
                  font-family:SourceHanSansCN-Medium,SourceHanSansCN!important;
                  font-weight: 500;
              }
              span {
                  display: inline-block;
                  vertical-align: top;
                  box-sizing: border-box;
              }
              span:nth-of-type(1) {
                  width: 119px;
                  // padding-left: 18px;
              }
              span:nth-of-type(2) {
                  padding-left: 14px;
                  padding-right: 14px;
                  width: 310px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
              }
              span:nth-of-type(3) {
                  width: 74px;
              }
              span:nth-of-type(4) {
                  width: 114px;
                  padding-right: 14px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
              }
              span:nth-of-type(5) {
                  width: 82px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
              }
              .special-item {
                  width: 600px!important;
              }
          }
          .course-item:hover {
              background-color: #F1F3F8;
              color: #0181FF!important;
          }
          .course-header {
              span {
                  font-size: 14px;
                  color: #5E5E5E;
                  font-weight: 400;
              }
          }
          .isSelect {
              background-color: #F1F3F8;
              color: #0181FF;
          }
          .isEnd {
              background-color: #F4F5FA;
              color: #a4a4a7;
          }
        }
        .list-title {
          height: 43px;
          margin-bottom: 0;
        }
      }
    }
    .btns {
      .practice, .start-class-btn {
        width: 328px;
        background-color: #0181FF!important;
      }
      .practice {
        padding-left: 10px;
      }
    }
  }
</style>

<style lang="scss">
.org-popover {
  padding: 0;
  ul {
    padding: 5px 0 0 0;
    height: 150px;
    overflow-y: auto;
    li {
      padding: 0 16px;
      width: 230px;
      height: 43px;
      line-height: 43px;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    li:hover {
      color: #0181FF;
      background-color: #F1F3F8;
    }
    .isOrgSelect {
      color: #0181FF;
      background-color: #F1F3F8;
    }
  }
}
.popper__arrow {
  left: 30px!important;
}
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar
{
    width: 5px;
    height: 5px;
    /* background-color: #DADDE6;   */
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
    border-radius: 10px;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #DADDE6;
}
/*滑块效果*/
::-webkit-scrollbar-thumb:hover
{
border-radius: 5px;
}
</style>
